import { defineNuxtPlugin } from "#imports";
import Rollbar from "rollbar";
import type { ModuleOptions } from "..";

const isValidAccessToken = (accessToken: unknown): accessToken is string => {
    return typeof accessToken === "string" && accessToken.length > 0;
};

export default defineNuxtPlugin(({ $config, hook }) => {
    const { clientAccessToken, config } = $config.public.rollbar as ModuleOptions;
    const serverAccessToken = $config.__rollbarServerAccessToken;

    const accessToken = import.meta.client ? clientAccessToken : serverAccessToken;

    if (!isValidAccessToken(accessToken)) {
        const side = import.meta.client ? "client" : "server";
        return console.error(
            `Skipping Rollbar initialization on ${side} side. Please provide a valid ${side}AccessToken.`
        );
    }

    const rollbar = new Rollbar({
        ...config,
        accessToken,
    });

    // Called when a fatal error occurs
    hook("app:error", (error) => {
        rollbar.error(error as Error);
    });

    return {
        provide: { rollbar },
    };
});
